import api from './api';

export const getDashboard = () => api.get('/api/friends/dashboard');
export const searchPlayers = (q) => api.get('/api/friends/search', { params: { q } });
export const sendRequest = (receiverId) => api.post('/api/friends/request', { receiverId });
export const acceptRequest = (friendshipId) => api.post(`/api/friends/${friendshipId}/accept`);
export const rejectRequest = (friendshipId) => api.post(`/api/friends/${friendshipId}/reject`);
